import { Component, Input, inject } from '@angular/core';

import { ContentBlockModel } from './@shared/content-block.model';
import { InAppBrowserService } from 'src/app/@core/in-app-browser.service';
import { IonicSlides } from '@ionic/angular';
import { ProtoImageModel } from 'src/app/@shared/proto-image/proto-image.model';
import { SwiperOptions } from 'swiper/types/swiper-options';

@Component({
  selector: 'proto-content-block',
  standalone: false,
  styleUrls: ['./content-block.component.scss'],
  templateUrl: './content-block.component.html',
})
export class ContentBlockComponent {
  @Input() public block: ContentBlockModel;

  public swiperOptions: SwiperOptions = {
    breakpoints: {
      768: {
        centeredSlides: false,
        slidesPerView: 3,
      },
    },
    modules: [IonicSlides],
  };

  /**
   * Workaround to make the swiper work inside a component without declaring CUSTOM_ELEMENTS_SCHEMA in a module.
   * The swiper needs a directive to work and that is provided by *ngIf.
   * TODO: implement custom swiper directive (see ´https://medium.com/@fbanyai/swiper-10-angular-16-uncovered-1721bf32dfd6`)
   */
  public swiperDirectiveWorkaround: boolean = true;

  private inAppBrowserService = inject(InAppBrowserService);

  // TODO: This should maybe be handled withing proto image?
  public openImage(image: ProtoImageModel): void {
    if (!image) {
      return;
    }

    this.inAppBrowserService.openUrl(image.urls.original);
  }

  public openUrl(url: string): void {
    if (!url) {
      return;
    }

    this.inAppBrowserService.openUrl(url);
  }
}
